/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';
import { IDescriptorBody } from '../../../descriptor';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IStringBytesPacketDataMessage extends IPackageDataMessage {
	data: string;
	data1: Buffer;
}

export default class StringBytesPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.STRING, MessageDataTypes.BUFFER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'StringBytesPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'bytes',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: string, public readonly data1: Buffer ) {
		super();
	}

	public toJSON(): IStringBytesPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: IStringBytesPacketDataMessage ): StringBytesPacketDataMessage {
		return new StringBytesPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: string, data1: Buffer ): StringBytesPacketDataMessage {
		return new StringBytesPacketDataMessage( data, data1 );
	}
}
